/* eslint-disable no-lonely-if */
/* eslint-disable arrow-parens */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { authAction, applicantAction, changeLanguageBasedOnParam } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import { LayoutWithNavbar } from 'layouts';
import {
  Stepper, Input, FormElementContainer,
  CountryCodeDropdown,
} from 'components';
import IconEnter from 'assets/icons/enter.svg';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { PATH, IS_LOGOUT } from 'shared/constant';
// import validation from 'shared/validations';
// import {
//   GoogleReCaptchaProvider,
//   GoogleReCaptcha,
//   // useGoogleReCaptcha
// } from 'react-google-recaptcha-v3';

let interval = null;

const Mobile = ({
  token, history, onSaveRefCode, latestRefCode, onSaveLatestRefCode, currentRefCode,
  onSaveProductCode, isUserExisting, onSwitchLanguage, onUpdatePhoneNumber, onUpdateEmailAddress,
  intl, emailAddress, phoneNumber, onRequestOTP, location: { state }, onGetApplicantDetails,
}) => {
  const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY; // '6Lc6ikQjAAAAALuLq3pJzzC92mFxU7Gka5I-egXp';
  const [isEmailForm, setIsEmailForm] = useState(false);
  const [countryCode, setCountryCode] = useState('KW');
  const [dialCode, setDialCode] = useState('+965');
  const [mobile, setMobile] = useState('');
  const [withRefProductCode, setWithRefProductCode] = useState(false);
  const [tokenCaptcha, setTokenCaptcha] = useState('');
  const [timer, setTimer] = useState(120);
  // const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  useEffect(() => {
    // Ensure the reCAPTCHA script is loaded before executing
    if (window.grecaptcha) {
      window.grecaptcha.ready(() => {
        // Programmatically invoke the reCAPTCHA challenge
        window.grecaptcha.execute(captchaKey, { action: 'homepage' }).then((rToken) => {
          // Save token on the state
          // console.log('reCAPTCHA Token:', rToken);
          setTokenCaptcha(rToken);
        });
      });
    }
  }, [captchaKey]);

  const resendCodeDuration = () => {
    interval = setInterval(() => {
      setTimer(prevState => prevState - 1);
    }, 1000);
  };

  const handleRecaptchaExecute = React.useCallback(() => {
    if (window.grecaptcha) {
      window.grecaptcha.execute(captchaKey, { action: 'resend_otp' }).then((rToken) => {
        // Set the token in the state
        setTokenCaptcha(rToken);
      });
    }
  }, [captchaKey]);

  // Get new google token after 2 mins
  useEffect(() => {
    resendCodeDuration();

    if (timer === 0) {
      // setRefreshReCaptcha(r => !r);
      clearInterval(interval);
      setTimer(120);
      handleRecaptchaExecute();
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer, handleRecaptchaExecute]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.getAll('refCode').toString();
    const productCode = urlParams.getAll('productCode').toString();
    const isEmailType = urlParams.getAll('type').toString();
    const locale = urlParams.getAll('lang').toString();

    if (locale) {
      onSwitchLanguage(locale);
    }

    // Force on load or when user refresh page to show Kuwait country code
    // if (!token && isEmailType !== 'email') {
    //   const kwDialCode = '+965';
    //   onUpdatePhoneNumber(kwDialCode);
    // }

    if (isEmailType === 'email') {
      setIsEmailForm(true);
      if (isUserExisting) {
        history.push(PATH.LOGIN);
        setIsEmailForm(false);
      }
    } else {
      setIsEmailForm(false);
    }

    /** If product code exist, save it on the Store */
    if (productCode) {
      onSaveProductCode(productCode);
      setWithRefProductCode(true);
    }

    /** Handle refCode (Only update refCode when user is not yet authenticated) */
    if (refCode && !token) {
      if (latestRefCode && latestRefCode !== '') {
        //* * Case: when user logout and get new refCode :: Add refCode new */
        if (latestRefCode === IS_LOGOUT) {
          onSaveRefCode(refCode);
        } else {
          onSaveRefCode(currentRefCode);
        }
      } else {
        onSaveRefCode(refCode);
      }
      onSaveLatestRefCode(refCode);
    }

    if (token) {
      /** if product code exist, get applicant details to fix the auto fill of mutual funds */
      if (productCode) onGetApplicantDetails(true);
      history.push(PATH.HOME);
    }
  }, [
    onSwitchLanguage, onUpdatePhoneNumber, onSaveRefCode, onSaveLatestRefCode,
    currentRefCode, isUserExisting, latestRefCode, onSaveProductCode, token, history, onGetApplicantDetails,
  ]);

  // const emailValidation = (email, intlanguage) => ({
  //   isValid: validation.emailSchema(intlanguage).isValidSync({ email }),
  //   errorMessage: validation.getErrorMessages({ email }, validation.emailSchema(intlanguage)),
  // });

  // const mobileValidation = (phone, intlanguage) => ({
  //   isValid: validation.mobileSchema(intlanguage).isValidSync({ phone }),
  //   errorMessage: validation.getErrorMessages({ phone }, validation.mobileSchema(intlanguage)),
  // });

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const onHandleCountryChange = (country) => {
    setCountryCode(country.isoCode);
    setDialCode(country.dialCode);
    onUpdatePhoneNumber(country.dialCode);
  };

  const handleInputChange = ({ target: { value } }) => {
    setMobile(value);
    onUpdatePhoneNumber(dialCode + value);
  };

  const handleEmailInputChange = ({ target: { value } }) => {
    onUpdateEmailAddress(value);
  };

  const handleRedirectOTP = () => {
    if (isEmailForm) {
      // emailValidation(emailAddress, intl);
      // console.log(emailValidation(emailAddress));

      if (emailAddress && !!isValidEmail(emailAddress)) {
        onRequestOTP(isEmailForm, tokenCaptcha);
        history.push({
          pathname: PATH.OTP,
          state: {
            digit: '',
            isFromLogin: state && state.isFromLogin,
          },
        });
      }
    } else {
      // mobileValidation(phoneNumber, intl);
      // console.log(this.mobileValidation(phoneNumber, intl));

      if (phoneNumber && phoneNumber.length >= 11) {
        onRequestOTP(isEmailForm, tokenCaptcha).then(res => {
          history.push({
            pathname: PATH.OTP,
            state: {
              digit: phoneNumber.slice(-4),
              isFromLogin: true,
              withRefProductCode,
              recaptchaToken: tokenCaptcha,
            },
          });
        });
      }
    }
  };

  // const handleVerify = useCallback((tokenArg) => {
  //   // console.log('google captcha ', tokenArg);
  //   setTokenCaptcha(tokenArg);
  // }, []);

  return (
    <div className="page-container">
      <Stepper isStep1Active />

      {!isEmailForm ? (
        <article className="page-container__content page-container__content--small page-container__content--adjustMarginTop">
          <p><strong><FormattedMessage id="auth.heading" /></strong></p>
          <p>
            <small>
              <FormattedHTMLMessage id="auth.desc" />
            </small>
          </p>
          <br />

          <FormElementContainer isWithIconButton isMultpleElements customClass="with-dropdown">
            {/* <SimpleSelectBox dataList={countryCodes.map(item => item.name)} /> */}
            <CountryCodeDropdown value={countryCode} onChange={onHandleCountryChange} />
            <Input
              onInputChange={handleInputChange}
              value={mobile}
              placeholder={intl.formatMessage({ id: 'auth.placeholder' })}
                // isValid={mobileValidation(phoneNumber, intl).isValid}
                // errorMessage={mobileValidation(phoneNumber, intl).errorMessage}
              isValid={phoneNumber.length >= 11}
              errorMessage={[intl.formatMessage({ id: 'validation.invalidMobile' })]}
            />
            <img src={IconEnter} className="enter-button" alt="Enter Key" onClick={handleRedirectOTP} />
          </FormElementContainer>
          {/* <div className="auth-recaptcha">
              <GoogleReCaptcha
                onVerify={handleVerify}
                refreshReCaptcha={refreshReCaptcha}
              />
            </div> */}
          {/* <div className="auth-submit">
              <Button isSecondary value={intl.formatMessage({ id: 'navbar.signIn' })} onClick={handleRedirectOTP} />
            </div> */}
        </article>
      ) : (
        <article className="page-container__content page-container__content--small page-container__content--adjustMarginTop">
          <p><strong><FormattedMessage id="auth.headingEmail" /></strong></p>
          <p>
            <small>
              <FormattedHTMLMessage id="auth.desc" />
            </small>
          </p>
          <span style={{ display: 'none' }}>{emailAddress}</span>
          <br />
          <FormElementContainer isWithIconButton isMultpleElements>
            <Input
              onInputChange={handleEmailInputChange}
              value={emailAddress}
              placeholder={intl.formatMessage({ id: 'auth.emailPlaceholder' })}
              isValid={isValidEmail(emailAddress)}
              errorMessage={[intl.formatMessage({ id: 'validation.emailRequired' })]}
            />
            <img src={IconEnter} className="enter-button" alt="Enter Key" onClick={handleRedirectOTP} />
          </FormElementContainer>
        </article>
      )}

      <span style={{ display: 'block', marginBottom: '10px' }} />
    </div>
  );
};

const mapStateToProps = state => ({
  phoneNumber: selectors.getPhoneNumber(state),
  emailAddress: selectors.getAuthEmailAddress(state),
  isUserExisting: selectors.getAuthIsUseExisting(state),
  token: selectors.getToken(state),
  latestRefCode: selectors.getLatestRefCode(state),
  currentRefCode: selectors.getRefCode(state),
});

const mapDispatchToProps = dispatch => ({
  onGetApplicantDetails: (bool) => dispatch(applicantAction.getApplicantDetails(bool)),
  onUpdatePhoneNumber: phoneNumber => dispatch(authAction.updatePhoneNumber(phoneNumber.replace(/\s/g, ''))),
  onUpdateEmailAddress: emailAddress => dispatch(authAction.updateEmailAddress(emailAddress)),
  onRequestOTP: (isEmail, captchaToken) => dispatch(authAction.requestOTP(isEmail, captchaToken)),
  onSaveRefCode: refCode => dispatch(applicantAction.saveRefCode(refCode)),
  onSaveLatestRefCode: refCode => dispatch(applicantAction.saveLatestRefCode(refCode)),
  onSaveProductCode: id => dispatch(applicantAction.saveProductCode(id)),
  onSwitchLanguage: (locale) => dispatch(changeLanguageBasedOnParam(locale)),
});
export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithNavbar(injectIntl(Mobile)));
